function unfold(o, prefix) {
  for (const [k, v] of Object.entries(o)) {
    if (v && typeof v === 'object') {
      unfold(v, prefix ? `${prefix}.${k}` : k);
    } else {
      o[k] = prefix ? `${prefix}.${v}` : v;
    }
  }
}

export const Action = {
  Api: {
    Base: 'Api',
    Clear: 'Clear',
  },
  Auth: {
    LoginRequested: 'Login',
    LoginCompleted: 'Login_FULFILLED',
    LoginPending: 'Login_PENDING',
    LogoutRequested: 'Logout',
    LoggedOut: 'Logout_FULFILLED',
  },
  Payment: {
    WexMismatch: {
      GetWexMismatch: 'Got_Wex_Mismatch',
      GetWexMismatchCompleted: 'Got_Wex_Mismatch_FULFILLED',
      SaveWexMatch: 'Save_Wex_Match',
      SaveWexMatchCompleted: 'Save_Wex_Match_FULFILLED',
    },
    Unbalanced: {
      Cache: 'Cache',
    },
    Dwolla: {
      CancelCancel: 'CancelCancel',
      CancelConfirmationRequested: 'ConfirmCancel',
      CancelRequested: 'Cancel',
      CancelPending: 'Cancel_PENDING',
      CancelCompleted: 'Cancel_FULFILLED',
      SetPageSize: 'PageSize',
      LoadRequested: 'Load',
      LoadPending: 'Load_PENDING',
      LoadCompleted: 'Load_FULFILLED',
      PageRequested: 'Page',
      SettingPage: 'Page_PENDING',
      BalanceRequested: 'Bal',
      BalanceLoaded: 'Bal_FULFILLED',
    },
    WexCards: {
      LoadRequested: 'Load',
      LoadPending: 'Load_PENDING',
      LoadCompleted: 'Load_FULFILLED',
      PageRequested: 'Page',
      SettingPage: 'Page_PENDING',
    },
  },
  Poi: {
    DetailsRequested: 'PoiDetail',
    DetailsCompleted: 'PoiDetail_FULFILLED',
    BrandsRequested: 'Brands',
    BrandsCompleted: 'Brands_FULFILLED',
    BrandRequested: 'Brand',
    BrandCompleted: 'Brand_FULFILLED',
    BrandUpdateRequested: 'UpdateBrand',
    BrandUpdateCompleted: 'UpdateBrand_FULFILLED',
    BrandCreateRequested: 'CreateBrand',
    BrandCreateCompleted: 'CreateBrand_FULFILLED',
    BrandLogoIncrementRequested: 'IncrementBrandLogo',
    BrandLogoIncrementCompleted: 'IncrementBrandLogo_FULFILLED',
    PoiBrandSave: 'PoiBrand',
    PoiBrandPending: 'PoiBrand_PENDING',
    PoiBrandCompleted: 'PoiBrand_FULFILLED',
    PoiBrandRemove: 'PoiBrandRemove',
    PoiBrandRemovePending: 'PoiBrandRemove_PENDING',
    PoiBrandRemoveCompleted: 'PoiBrandRemove_FULFILLED',
    PoiPayStatusSave: 'PoiPayStatusSave',
    PoiPayStatusPending: 'PoiPayStatusSave_PENDING',
    PoiPayStatusCompleted: 'PoiPayStatusSave_FULFILLED',
  },
  System: {
    Logs: {
      DetailRequested: 'Detail',
      DetailPending: 'Detail_PENDING',
      DetailCompleted: 'Detail_FULFILLED',
      LoadRequested: 'Load',
      LoadPending: 'Load_PENDING',
      LoadCompleted: 'Load_FULFILLED',
      ForgetDetails: 'Forget',
    },
  },
  Identity: {
    User: {
      DetailRequested: 'Detail',
      DetailPending: 'Detail_PENDING',
      DetailCompleted: 'Detail_FULFILLED',
      TxPageRequested: 'Tx',
      TxPageCompleted: 'Tx_FULFILLED',
    },
    Users: {
      SearchRequested: 'Search',
      SearchRequestedCompleted: 'Search_FULFILLED',
    },
  },
};

unfold(Action);
